import { SearchInput } from '../shared';
import { SortOrder, ProvinceSortType } from '../enums';

export class GetProvincesInput extends SearchInput<ProvinceSortType> {
    public countryId?: number | null;

    constructor() {
        super(ProvinceSortType.Name);
        this.countryId = null;
        this.sortOrder = SortOrder.Ascending;
    }
}
